import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddLoyalityPoints({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [pointsType, setPointsType] = useState<"add" | "remove">("add");

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Adjust Loyalty Points</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="control_group">
              <label htmlFor="pointsType">Adjusted Points Type</label>
              <RadioGroup
                id="pointsType"
                className="flex mt_10"
                value={pointsType}
                onChange={(e) =>
                  setPointsType(e.target.value as "add" | "remove")
                }
              >
                <FormControlLabel
                  value="add"
                  control={<Radio />}
                  label="Add Points"
                />
                <FormControlLabel
                  value="remove"
                  control={<Radio />}
                  label="Remove Points"
                />
              </RadioGroup>
            </div>

            {(pointsType === "remove" || pointsType === "add") && (
              <div className="control_group">
                <label htmlFor="points">Points</label>
                <TextField
                  id="points"
                  type="number"
                  variant="outlined"
                  placeholder="Enter Points here"
                  fullWidth
                  hiddenLabel
                />
              </div>
            )}

            {pointsType === "remove" && (
              <div className="control_group">
                <label htmlFor="reason">Reason</label>
                <TextField
                  id="reason"
                  variant="outlined"
                  placeholder="Enter reason for removing points"
                  fullWidth
                  hiddenLabel
                  maxRows={4}
                  minRows={4}
                  multiline
                />
              </div>
            )}

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
